:host {

    :hover {
        cursor: pointer;
    }

    a {
        display: flex;
    }

    span {
        white-space: pre-wrap;
        word-break: break-word;
    }

    .ti-notify-me-svg-icon {
        margin-right: $polaris-space-1;
    }
}
